import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { TessadataService } from '../../../data-access-layer/tessadata.service';
import { DatasetService } from '../../../data-access-layer/dataset/dataset.service';
import { ProfilePolygonService } from '../../../shared/services/profile-polygon.service';
import { Point } from '../../../model/geometry/point';
import { TessadataLocationDetails } from '../../../core/tessadata/tessadata-location-details';
import { DownloadService } from '../../../data-access-layer/download/download.service';
import { AttachmentUtils } from '../../../core/utils/attachment-utils';
import { Observable, Subscription, forkJoin, of } from 'rxjs';
import { GoogleGeocodingService } from 'src/app/shared/services/google-geo-coder.service';
import { catchError, filter, map, mergeMap, switchMap, take, tap } from 'rxjs/operators';
import { TessadataDatasetStructure } from 'src/app/core/tessadata/tessadata-dataset-structure';
import { TessadataFieldsValues } from '../../../core/tessadata/tessadata-fields-values';
import { MapStateService } from '../../../map/map-state.service';
import { DataPointsServiceState } from '../../../shared/services/datapoints-service-state';
import {NotifService} from '../../../core/notification/notif.service';
import { EChartsOption } from 'echarts';
import { ClimateOverlayPermission, DatapointsClimateChartService } from '../climate-charts/datapoints-climate-chart.service';
import { EMPTY_PROFILE, ExternalDataFetchingAPIKeys, LocationProfile, MUNICHRE_ARRAY,/* TENSORFLIGHT_ARRAY, TENSORFLIGHT_POLYGON_DATA_KEY*/ PRECISELY_BUILDING_ARRAY, PRECISELY_BUILDING_GEOMETRY_KEY, PRECISELY_CRIME_ARRAY, PRECISELY_WILDFIRE_RISK_ARRAY } from 'src/app/model/datapoint/location-profile/location-profile';
import { AerisService } from 'src/app/data-access-layer/aeris.service';
import { AerisType } from 'src/app/core/aeris/AerisType';
import { Aeris } from 'src/app/core/utils/aeris';
import { AerisData } from '../datapoints-location-profile/location-profile/location-profile.component';
import { isNullOrUndefined, isUndefined } from "src/app/core/utils/util-master";
import { Climate } from 'src/app/core/utils/climate';
import { TessadataDataset } from 'src/app/core/tessadata/tessadata-dataset';
import { isEnabled } from 'src/environments/environment';
import { Functionalities } from 'src/environments/app-functionalities';
import { ComputationUtils } from 'src/app/core/utils/computation-utils';
import { DistanceUnit } from 'src/app/constants';
import { PoiClosestFilter } from 'src/app/model/datapoint/filter/poi-closest-filter';
import { MaptycsTheme } from '../climate-charts/custom-theme';
import { keepRegionLevelsBetweenTicks, RegionChartItem, toRegionChartItem } from '../climate-charts/region-chart';
import { BioclimaticRegion } from 'src/app/model/climate/bioclimatic-region';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { DialogModel } from 'src/app/model/dialog/dialog-model';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { DatasetFieldType } from 'src/app/model/dataset/dataset-field-type';
import { MinuchRe } from 'src/app/core/utils/minuch-re';
import { ClimateService } from 'src/app/data-access-layer/climate.service';
import { ClimateChartHelper } from '../climate-charts/util/climate-chart-helper';
import { ClimateChart, InstantOverlayScores } from 'src/app/model/climate/climate-chart';
import { ConsolidatedRiskScoreChartService } from '../climate-charts/consolidated-risk-score-chart.service';
import { ConsolidatedRiskScoreChartItem } from '../datapoints-location-profile/location-profile/location-profile.component';
import { SidePanelService } from 'src/app/shared/services/side-panel.service';
import { TessadataNriFields } from 'src/app/core/tessadata/tessadata-nri-fields';
import { NRIUtils } from 'src/app/core/tessadata/nri-utils';
import { UserStateService } from 'src/app/auth/user-state-service';
import { ActivityConfigService } from 'src/app/account/consolidated-risk-score/services/activity-config.service';
import {
    Activity,
    Indicator,
    IndicatorValue,
    isNotApplicableProfile,
} from 'src/app/account/consolidated-risk-score/model/activity-config.model';

@Component({
    selector: 'map-address-location-profile',
    templateUrl: './address-location-profile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./address-location-profile.component.scss',
        '../datapoints-location-profile/location-profile/location-profile.component.scss',
        '../datapoints-location-profile/datapoints-profile-panel.component.scss']
})
export class AddressLocationProfileComponent implements OnInit, OnDestroy {
    isExpanded = false;
    isLoading = false;
    requestFailed = false;
    location: Point;
    currentPinAddress: Observable<string>;
    locationDetails: TessadataLocationDetails;

    initMaxTempOption: EChartsOption;
    initMeanTempOption: EChartsOption;
    initMinTempOption: EChartsOption;
    initSnowfallOption: EChartsOption;
    initPrecipitationOption: EChartsOption;
    initSurfaceWindOption: EChartsOption;
    initPopulationDensityOption: EChartsOption;
    initSeaLevelRiseOption: EChartsOption;
    initSeaLevelRiseWarmingOption: EChartsOption;
    initSpi6ChangeOption: EChartsOption;
    initSpi6ScoreOption: EChartsOption;
    initCoolingDegreeDaysOption: EChartsOption;
    initCoolingDegreeDaysScoreOption: EChartsOption;
    initCoolingDegreeDaysChangeOption: EChartsOption;
    initTxxOption: EChartsOption;
    initTxxScoreOption: EChartsOption;
    initTxxChangeOption: EChartsOption;
    initClimateTOption: EChartsOption;
    initClimateTScoreOption: EChartsOption;
    initClimateTChangeOption: EChartsOption;
    initFrostDaysOption: EChartsOption;
    initFrostDaysScoreOption: EChartsOption;
    initFrostDaysChangeOption: EChartsOption;
    initHeatingDegreeDaysOption: EChartsOption;
    initHeatingDegreeDaysScoreOption: EChartsOption;
    initHeatingDegreeDaysChangeOption: EChartsOption;
    initExtremeHotDaysOption: EChartsOption;
    initExtremeHotDaysScoreOption: EChartsOption;
    initExtremeHotDaysChangeOption: EChartsOption;
    initVeryExtremeHotDaysOption: EChartsOption;
    initVeryExtremeHotDaysScoreOption: EChartsOption;
    initVeryExtremeHotDaysChangeOption: EChartsOption;
    initClimatePrOption: EChartsOption;
    initClimatePrScoreOption: EChartsOption;
    initClimatePrChangeOption: EChartsOption;
    initClimateCddOption: EChartsOption;
    initClimateCddScoreOption: EChartsOption;
    initClimateCddChangeOption: EChartsOption;
    initClimateRx1dayOption: EChartsOption;
    initClimateRx1dayScoreOption: EChartsOption;
    initClimateRx1dayChangeOption: EChartsOption;
    initClimateRx5dayOption: EChartsOption;
    initClimateRx5dayScoreOption: EChartsOption;
    initClimateRx5dayChangeOption: EChartsOption;
    initClimatePrsnOption: EChartsOption;
    initClimatePrsnScoreOption: EChartsOption;
    initClimatePrsnChangeOption: EChartsOption;
    initClimateSstOption: EChartsOption;
    initClimateSstScoreOption: EChartsOption;
    initClimateSstChangeOption: EChartsOption;
    initClimateSfcWindOption: EChartsOption;
    initClimateSfcWindScoreOption: EChartsOption;
    initClimateSfcWindChangeOption: EChartsOption;
    initClimateTrOption: EChartsOption;
    initClimateTrScoreOption: EChartsOption;
    initClimateTrChangeOption: EChartsOption;
    initClimateSlrOption: EChartsOption;
    initClimateSlrScoreOption: EChartsOption;
    initClimateSlrChangeOption: EChartsOption;
    @Input() datasetID: any;
    _dropdownSelectedValue: string;

    locationProfile = new LocationProfile();
    selectedAddressPoint: Point;
    airQualityData: AerisData[] = [];
    meteorologicalConditionsData: AerisData[] = [];
    forecastData: AerisData[] = [];
    tropicalCyclonesData: AerisData[] = [];
    alertsData: AerisData[] = [];
    convectiveData: AerisData[] = [];
    droughtsData: AerisData[] = [];
    firesOutlookData: AerisData[] = [];
    earthquakesData: AerisData[] = [];
    firesData: AerisData[] = [];
    placesData: AerisData[] = [];
    riversData: AerisData[] = [];
    stormCellsData: AerisData[] = [];
    threatsData: AerisData[] = [];

    tessadataEnabled = isEnabled(Functionalities.TESSADATA_DATA);
    tessadataPOIDetails: TessadataFieldsValues[]; //each entry belongs to a new POI
    tessadataPOIDataset: TessadataDataset;
    tessadataPOIDistance: number = 100; //maybe extract this into constants
    tessadataPOIDistanceUnit: DistanceUnit = DistanceUnit.KM;
    tessadataPOISubmittedDistanceUnit: DistanceUnit = DistanceUnit.KM;
    tessadataPOILimit: number = 5; //maybe extract this into constant
    testdataInputParameters: {address: Point, tessadataPOIDatasets: TessadataDataset[], tessadataPOIDatasetsStructures: TessadataDatasetStructure[]} = {address: {x: 0, y: 0}, tessadataPOIDatasets: [], tessadataPOIDatasetsStructures: []};
    address: string = null;
    maptycsTheme = MaptycsTheme;
   // tensorflightFieldsMetaData: any[] = [];
    munichreFieldsMetaData: any[] = [];
    preciselyFieldsMetaData: any[] = [];
    preciselyCrimeFieldsMetaData: any[] = [];
    preciselyCrimeFieldsWithValues: any[] = [];
    preciselyWildfireRiskFieldsMetaData: any[] = [];
    preciselyWildfireRiskFieldsWithValues: any[] = [];
    private readonly subscriptions: Subscription = new Subscription();

    hazardScores : any;
    riskScores = MinuchRe.RiskScoresElements();
    dataForSeeInfo: any;

    displayedColumns: string[] = ['name', 'none', 'low'];

    displayedRiskColumns: string[] = ['name', 'none', 'low'];
    EMPTY_PROFILE = EMPTY_PROFILE;
    activeProfile: string;

    climatologyActiveTab: 'CLIMATOLOGY' | 'CHANGE' | 'RISK_SCORING' | 'REGION' | 'CONSOLIDATED_RISK_SCORE' = 'RISK_SCORING';
    bioclimaticZonesEnabled = false;
    regionLoading = false;
    regionCharts: RegionChartItem[] = [];
    private regionRequest: Subscription | null = null;
    // Shown in the profile data section, so loaded with the address rather than with the Region tab.
    bioclimaticRegion: BioclimaticRegion | null = null;
    private bioclimaticRegionRequest: Subscription | null = null;


    summaryCard: NRICard;
    nriCards: NRICard[] = [];

    // Consolidated Risk Score - instant calculation (FR-1.60, same behavior as the Location
    // Panel's FR-1.50-1.56): a live score for this address, computed from percentages the
    // user may edit, never saved or persisted. An address has no datapoint, so - unlike the
    // location panel - there is no stored field to read an "existing" score from; instead
    // the existing score is computed live too, from the saved (unedited) percentages, using
    // the exact same compute call the edited "Calculate" uses.
    instantVulnerabilityProfiles: Activity[] = [];
    instantIndicators: Indicator[] = [];
    instantOptionsLoaded = false;
    instantLoadingOptions = false;
    instantLoadingConfig = false;
    instantCalculating = false;
    instantSelectedProfileId: number | null = null;
    instantIndicatorValues: { [code: string]: number | null } = {};
    // The instant result is its own chart, kept separate so recalculating simply replaces it
    // An address has no stored chart to sit beside it (FR-1.68).
    instantChartItem: ConsolidatedRiskScoreChartItem | null = null;
    instantErrorMessage = '';

    constructor(
        private readonly tessadataService: TessadataService,
        private readonly datasetService: DatasetService,
        private readonly profilePolygonService: ProfilePolygonService,
        private cd: ChangeDetectorRef,
        private downloadService: DownloadService,
        public dataPointsServiceState: DataPointsServiceState,
        private geoCoderService: GoogleGeocodingService,
        private mapStateService: MapStateService,
        private notifService: NotifService,
        private datapointsClimateChartService: DatapointsClimateChartService,
        public readonly climateOverlayPermission: ClimateOverlayPermission,
        private aerisService: AerisService,
        public readonly dialog: MatDialog,
        private readonly route: ActivatedRoute,
        private readonly sidePanelService: SidePanelService,
        private readonly climateService: ClimateService,
        private readonly consolidatedRiskScoreChartService: ConsolidatedRiskScoreChartService,
        private readonly userStateService: UserStateService,
        private readonly activityConfigService: ActivityConfigService,
    ) {
        this.currentPinAddress = this.mapStateService.getCurrentPinAddress();
        this.initMaxTempOption = datapointsClimateChartService.maxTemperatureService.options;
        this.initMeanTempOption = datapointsClimateChartService.meanTemperatureService.options;
        this.initMinTempOption = datapointsClimateChartService.minTemperatureService.options;
        this.initSnowfallOption = datapointsClimateChartService.snowfallService.options;
        this.initPrecipitationOption = datapointsClimateChartService.precipitationService.options;
        this.initSurfaceWindOption = datapointsClimateChartService.surfaceWindService.options;
        this.initPopulationDensityOption = datapointsClimateChartService.populationDensityService.options;
        this.initSeaLevelRiseOption = datapointsClimateChartService.seaLevelRiseService.options;
        this.initSeaLevelRiseWarmingOption = datapointsClimateChartService.seaLevelRiseWarmingService.options
        this.initSpi6ChangeOption = datapointsClimateChartService.spi6ChangeService.options;
        this.initSpi6ScoreOption = datapointsClimateChartService.spi6ScoreService.options;
        this.initCoolingDegreeDaysOption = datapointsClimateChartService.coolingDegreeDaysService.options;
        this.initCoolingDegreeDaysScoreOption = datapointsClimateChartService.coolingDegreeDaysScoreService.options;
        this.initCoolingDegreeDaysChangeOption = datapointsClimateChartService.coolingDegreeDaysChangeService.options;
        this.initTxxOption = datapointsClimateChartService.txxService.options;
        this.initTxxScoreOption = datapointsClimateChartService.txxScoreService.options;
        this.initTxxChangeOption = datapointsClimateChartService.txxChangeService.options;
        this.initClimateTOption = datapointsClimateChartService.climateTService.options;
        this.initClimateTScoreOption = datapointsClimateChartService.climateTScoreService.options;
        this.initClimateTChangeOption = datapointsClimateChartService.climateTChangeService.options;
        this.initFrostDaysOption = datapointsClimateChartService.frostDaysService.options;
        this.initFrostDaysScoreOption = datapointsClimateChartService.frostDaysScoreService.options;
        this.initFrostDaysChangeOption = datapointsClimateChartService.frostDaysChangeService.options;
        this.initHeatingDegreeDaysOption = datapointsClimateChartService.heatingDegreeDaysService.options;
        this.initHeatingDegreeDaysScoreOption = datapointsClimateChartService.heatingDegreeDaysScoreService.options;
        this.initHeatingDegreeDaysChangeOption = datapointsClimateChartService.heatingDegreeDaysChangeService.options;
        this.initExtremeHotDaysOption = datapointsClimateChartService.extremeHotDaysService.options;
        this.initExtremeHotDaysScoreOption = datapointsClimateChartService.extremeHotDaysScoreService.options;
        this.initExtremeHotDaysChangeOption = datapointsClimateChartService.extremeHotDaysChangeService.options;
        this.initVeryExtremeHotDaysOption = datapointsClimateChartService.veryExtremeHotDaysService.options;
        this.initVeryExtremeHotDaysScoreOption = datapointsClimateChartService.veryExtremeHotDaysScoreService.options;
        this.initVeryExtremeHotDaysChangeOption = datapointsClimateChartService.veryExtremeHotDaysChangeService.options;
        this.initClimatePrOption = datapointsClimateChartService.climatePrService.options;
        this.initClimatePrScoreOption = datapointsClimateChartService.climatePrScoreService.options;
        this.initClimatePrChangeOption = datapointsClimateChartService.climatePrChangeService.options;
        this.initClimateCddOption = datapointsClimateChartService.climateCddService.options;
        this.initClimateCddScoreOption = datapointsClimateChartService.climateCddScoreService.options;
        this.initClimateCddChangeOption = datapointsClimateChartService.climateCddChangeService.options;
        this.initClimateRx1dayOption = datapointsClimateChartService.climateRx1dayService.options;
        this.initClimateRx1dayScoreOption = datapointsClimateChartService.climateRx1dayScoreService.options;
        this.initClimateRx1dayChangeOption = datapointsClimateChartService.climateRx1dayChangeService.options;
        this.initClimateRx5dayOption = datapointsClimateChartService.climateRx5dayService.options;
        this.initClimateRx5dayScoreOption = datapointsClimateChartService.climateRx5dayScoreService.options;
        this.initClimateRx5dayChangeOption = datapointsClimateChartService.climateRx5dayChangeService.options;
        this.initClimatePrsnOption = datapointsClimateChartService.climatePrsnService.options;
        this.initClimatePrsnScoreOption = datapointsClimateChartService.climatePrsnScoreService.options;
        this.initClimatePrsnChangeOption = datapointsClimateChartService.climatePrsnChangeService.options;
        this.initClimateSstOption = datapointsClimateChartService.climateSstService.options;
        this.initClimateSstScoreOption = datapointsClimateChartService.climateSstScoreService.options;
        this.initClimateSstChangeOption = datapointsClimateChartService.climateSstChangeService.options;
        this.initClimateSfcWindOption = datapointsClimateChartService.climateSfcWindService.options;
        this.initClimateSfcWindScoreOption = datapointsClimateChartService.climateSfcWindScoreService.options;
        this.initClimateSfcWindChangeOption = datapointsClimateChartService.climateSfcWindChangeService.options;
        this.initClimateTrOption = datapointsClimateChartService.climateTrService.options;
        this.initClimateTrScoreOption = datapointsClimateChartService.climateTrScoreService.options;
        this.initClimateTrChangeOption = datapointsClimateChartService.climateTrChangeService.options;
        this.initClimateSlrOption = datapointsClimateChartService.climateSlrService.options;
        this.initClimateSlrScoreOption = datapointsClimateChartService.climateSlrScoreService.options;
        this.initClimateSlrChangeOption = datapointsClimateChartService.climateSlrChangeService.options;

        // Tracked so it is torn down in ngOnDestroy. Left untracked, a new subscription stacked up
        // every time this panel was re-created, and each surviving handler re-ran the whole block
        // below - which is why the boundary was fetched several times over and flickered.
        this.subscriptions.add(
        this.dataPointsServiceState.getActiveDropDownValueSubject().subscribe((value: string) => {
            this._dropdownSelectedValue = value;
            // Drop every Precisely polygon that is not the selected dataset's. Drawing is not done
            // here - see updateAddressProfilePolygons.
            this.updateAddressProfilePolygons();

            if (this._dropdownSelectedValue === this.locationProfile.CLIMATE) {
                this.prepareClimateCharts(this.selectedAddressPoint);
            } else if (this._dropdownSelectedValue === this.locationProfile.CLIMATE_CHANGE) {
                this.setClimatologyTab('RISK_SCORING');
                this.prepareClimatologyCharts(this.selectedAddressPoint);
            } else {
                Climate.resetGraphTypes(this.datapointsClimateChartService);
            }
            this.cd.detectChanges();
        }));
    }

    /**
     * Who may use the instant calculation section (FR-1.2/FR-1.3): Super Admin and Client
     * Admin, same as Account Settings - a Client Member can read stored scores but not test
     * a hypothetical percentage split.
     */
    get canAccessInstantCalculation(): boolean {
        const accountId = this.instantAccountId;
        return accountId != null && (this.userStateService.isSuperadmin || !!this.userStateService.isAccountAdmin(accountId));
    }

    /** Mirrors EditProfileDialogComponent's float-drift guard. */
    get instantTotalPercentage(): number {
        const total = this.instantIndicators.reduce((sum, indicator) => {
            const entered = this.instantIndicatorValues[indicator.code];
            const percentage = entered === null || entered === undefined || entered === ('' as any) ? 0 : Number(entered);
            return sum + (isNaN(percentage) ? 0 : percentage);
        }, 0);
        return Math.round(total * 100) / 100;
    }

    private get instantAccountId(): number | null {
        const accountId = this.route.snapshot.paramMap.get('accountId');
        return accountId ? Number(accountId) : null;
    }

    private loadInstantCalculationOptions() {
        if (this.instantOptionsLoaded || this.instantLoadingOptions) {
            return;
        }
        this.instantLoadingOptions = true;
        forkJoin({
            profiles: this.activityConfigService.getActivities(),
            indicators: this.activityConfigService.getIndicators(),
        }).subscribe({
            next: ({ profiles, indicators }) => {
                this.instantVulnerabilityProfiles = profiles;
                this.instantIndicators = indicators;
                this.instantOptionsLoaded = true;
                this.instantLoadingOptions = false;
                this.cd.detectChanges();
            },
            error: () => {
                this.instantErrorMessage = 'Failed to load vulnerability profile types.';
                this.instantLoadingOptions = false;
                this.cd.detectChanges();
            }
        });
    }

    /** A profile was picked (or cleared): load its saved percentages as the editable starting point. */
    /**
     * NOT APPLICABLE holds no percentages: they are fixed at 0% and read-only here, exactly as in
     * Account Settings and the Location Panel card.
     */
    get isInstantProfileNotApplicable(): boolean {
        const profile = this.instantVulnerabilityProfiles
            .find(candidate => candidate.id === this.instantSelectedProfileId);
        return isNotApplicableProfile(profile?.name);
    }

    onInstantProfileChange() {
        this.clearInstantResult();
        this.instantIndicatorValues = {};
        if (this.instantSelectedProfileId == null) {
            return;
        }
        if (this.isInstantProfileNotApplicable) {
            // Fixed at 0 rather than read from the saved config: the boxes are read-only, so they
            // have to show the value that will actually be used, and it is always 0.
            this.instantIndicators.forEach(indicator => (this.instantIndicatorValues[indicator.code] = 0));
            return;
        }
        const accountId = this.instantAccountId;
        if (accountId == null) {
            return;
        }
        this.instantLoadingConfig = true;
        this.activityConfigService.getConfig(accountId, this.instantSelectedProfileId).subscribe({
            next: (config) => {
                const valueByIndicatorId = new Map<number, number>();
                (config?.indicatorValues || []).forEach(indicatorValue => valueByIndicatorId.set(indicatorValue.indicatorId, indicatorValue.value));
                this.instantIndicators.forEach(indicator => {
                    const decimalValue = valueByIndicatorId.get(indicator.id);
                    this.instantIndicatorValues[indicator.code] = decimalValue !== undefined ? decimalValue * 100 : null;
                });
                this.instantLoadingConfig = false;
                this.cd.detectChanges();
            },
            error: () => {
                this.instantIndicators.forEach(indicator => (this.instantIndicatorValues[indicator.code] = null));
                this.instantLoadingConfig = false;
                this.cd.detectChanges();
            }
        });
    }

    onInstantInputChanged() {
        this.clearInstantResult();
    }

    private clearInstantResult() {
        // Deregistered as well as dropped: the download list is keyed by title, so a previous
        // result calculated against a different profile type would otherwise be exported
        // alongside the new one, pointing at a disposed chart instance (FR-1.65).
        if (this.instantChartItem) {
            this.deregisterConsolidatedRiskScoreGraph(this.instantChartItem.title);
        }
        this.datapointsClimateChartService.consolidatedRiskScoreInstantChart = null;
        this.instantChartItem = null;
        this.instantErrorMessage = '';
    }

    /**
     * Calculates the score for all 16 scenario/period combinations at once and draws them as a
     * chart (FR-1.62/FR-1.69). The profile type and its percentages are the whole input - the card
     * chooses no scenario or time period.
     *
     * An address carries no linkdata of its own, so this resolves the saved location at those
     * coordinates; an address with none nearby has nothing to calculate from.
     */
    /** The indicator Score charts loaded for this address, keyed by the overlay each was sampled from. */
    private loadedScoreCharts(): InstantOverlayScores[] {
        return Object.entries(this.datapointsClimateChartService.downloadClimatologyRequestPayload)
            .filter(([key, chart]) => key.endsWith('Score') && chart?.chartConfig?.typeName && chart.series)
            .map(([, chart]) => ({ overlayDatasetId: chart.chartConfig.typeName, series: chart.series }));
    }

    calculateInstantScore() {
        if (this.instantSelectedProfileId == null) {
            this.notifService.error('Please select a vulnerability profile type');
            return;
        }
        // NOT APPLICABLE is exempt from the 100% rule - it totals 0% by definition (FR-1.21).
        if (!this.isInstantProfileNotApplicable) {
            const total = this.instantTotalPercentage;
            if (total !== 100) {
                this.notifService.error(`Indicator percentages must total 100% - currently ${total}%`);
                return;
            }
        }

        this.instantCalculating = true;
        // Dropped up front: a recalculation replaces the previous result rather than adding to it
        // (FR-1.65), and leaving the old chart up while the new one loads reads as current.
        this.clearInstantResult();

        const indicatorValues: IndicatorValue[] = this.instantIndicators.map(indicator => {
            const entered = this.instantIndicatorValues[indicator.code];
            const percentage = entered === null || entered === undefined ? 0 : Number(entered);
            return { indicatorId: indicator.id, value: percentage / 100 };
        });

        // An address has no linkdata, so it is scored from the Risk Score charts this panel drew.
        const scoreCharts = this.loadedScoreCharts();
        if (!this.isInstantProfileNotApplicable && scoreCharts.length === 0) {
            this.instantErrorMessage = 'No climate risk scores are available for this address yet.';
            this.instantCalculating = false;
            return;
        }

        this.climateService.computeInstantConsolidatedRiskScoreChartByLocation(
            this.datasetID, this.instantSelectedProfileId, indicatorValues, scoreCharts
        ).subscribe({
            next: (chart) => {
                this.instantChartItem = this.toInstantChartItem(chart);
                if (!this.instantChartItem.hasData) {
                    this.instantErrorMessage = chart?.message
                        || 'No consolidated risk score available for this address.';
                } else {
                    // Handed to the download service so Download Data carries it as its own
                    // section: it is never stored, so it cannot be read back from anywhere.
                    this.datapointsClimateChartService.consolidatedRiskScoreInstantChart = chart;
                }
                this.instantCalculating = false;
                this.cd.detectChanges();
            },
            error: () => {
                this.instantErrorMessage = 'Failed to calculate the consolidated risk score.';
                this.instantCalculating = false;
                this.cd.detectChanges();
            }
        });
    }

    /**
     * Wraps the returned chart in the same item the location panel uses, so it inherits the bar,
     * line, tabular and save-image toolbox without a second renderer (AC-1.46). The backend
     * already prefixes the label with "Instant Calculation".
     */
    private toInstantChartItem(chart: ClimateChart): ConsolidatedRiskScoreChartItem {
        const profile = this.instantVulnerabilityProfiles
            .find(candidate => candidate.id === this.instantSelectedProfileId);
        const title = chart?.chartConfig?.yAxis?.labelName || `Instant Calculation ${profile?.name ?? ''}`.trim();
        const hasData = !!chart && chart.hasData !== false;

        return {
            profileId: this.instantSelectedProfileId,
            profileName: profile?.name ?? '',
            title,
            fileName: this.consolidatedRiskScoreChartService.toFileName(title),
            option: hasData ? this.consolidatedRiskScoreChartService.buildChartOptions(chart) : {} as EChartsOption,
            hasData,
            message: hasData ? undefined : (chart?.message || 'No consolidated risk score available for this address.')
        };
    }

    onConsolidatedRiskScoreChartInit(ec: any, item: ConsolidatedRiskScoreChartItem) {
        if (isUndefined(ec)) {
            return;
        }
        item.instance = ec;

        // Registered with the shared list so Download Chart appends it to the same PDF as the
        // other climate charts (FR-1.71).
        const graphs = this.datapointsClimateChartService.consolidatedRiskScoreGraphs;
        const existing = graphs.findIndex(graph => graph.title === item.title);
        if (existing === -1) {
            graphs.push({ title: item.title, instance: item.instance });
        } else {
            graphs[existing].instance = item.instance;
        }

        if (item.hasData && item.option) {
            setTimeout(() => {
                if (item.instance) {
                    ClimateChartHelper.attachDownloadHandler(item.instance, item.title, item.fileName);
                    item.instance.resize();
                }
            }, 0);
        }
    }

    private deregisterConsolidatedRiskScoreGraph(title: string) {
        const graphs = this.datapointsClimateChartService.consolidatedRiskScoreGraphs;
        const existing = graphs.findIndex(graph => graph.title === title);
        if (existing !== -1) {
            graphs.splice(existing, 1);
        }
    }

    @Input('location')
    set setLocationInput(data: {address: Point, externalPOIMenuItems: TessadataDataset[], externalPOIDatasetsStructures: TessadataDatasetStructure[]}) {
        this.setLocation(data);
    }

    get DistanceUnit() {
        return DistanceUnit;
    }

    onMaxTempChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.maxTemperature.instance = ec;
        }
        this.datapointsClimateChartService.maxTemperatureService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onMeanTempChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.meanTemperature.instance = ec;
        }
        this.datapointsClimateChartService.meanTemperatureService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onMinTempChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.minTemperature.instance = ec;
        }
        this.datapointsClimateChartService.minTemperatureService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSnowfallChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.snowfallTemperature.instance = ec;
        }
        this.datapointsClimateChartService.snowfallService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onPrecipitationChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.precipitation.instance = ec;
        }
        this.datapointsClimateChartService.precipitationService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSurfaceWindChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.surfaceWind.instance = ec;
        }
        this.datapointsClimateChartService.surfaceWindService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onPopulationDensityCharInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.populationDensity.instance = ec;
        }
        this.datapointsClimateChartService.populationDensityService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSeaLevelRiseChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.seaLevelRise.instance = ec;
        }
        this.datapointsClimateChartService.seaLevelRiseService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSeaLevelRiseWarmingChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.seaLevelRiseWarming.instance = ec;
        }
        this.datapointsClimateChartService.seaLevelRiseWarmingService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSpi6ChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.spi6Change.instance = ec;
        }
        this.datapointsClimateChartService.spi6ChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onSpi6ScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.spi6Score.instance = ec;
        }
        this.datapointsClimateChartService.spi6ScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onCoolingDegreeDaysChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDays.instance = ec;
        }
        this.datapointsClimateChartService.coolingDegreeDaysService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onCoolingDegreeDaysScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.coolingDegreeDaysScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onCoolingDegreeDaysChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.coolingDegreeDaysChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onTxxChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txx.instance = ec;
        }
        this.datapointsClimateChartService.txxService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onTxxScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txxScore.instance = ec;
        }
        this.datapointsClimateChartService.txxScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onTxxChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txxChange.instance = ec;
        }
        this.datapointsClimateChartService.txxChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateT.instance = ec;
        }
        this.datapointsClimateChartService.climateTService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTScore.instance = ec;
        }
        this.datapointsClimateChartService.climateTScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTChange.instance = ec;
        }
        this.datapointsClimateChartService.climateTChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onFrostDaysChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.frostDays.instance = ec;
        }
        this.datapointsClimateChartService.frostDaysService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onFrostDaysScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.frostDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.frostDaysScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onFrostDaysChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.frostDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.frostDaysChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onHeatingDegreeDaysChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.heatingDegreeDays.instance = ec;
        }
        this.datapointsClimateChartService.heatingDegreeDaysService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onHeatingDegreeDaysScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.heatingDegreeDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.heatingDegreeDaysScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onHeatingDegreeDaysChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.heatingDegreeDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.heatingDegreeDaysChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onExtremeHotDaysChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.extremeHotDays.instance = ec;
        }
        this.datapointsClimateChartService.extremeHotDaysService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onExtremeHotDaysScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.extremeHotDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.extremeHotDaysScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onExtremeHotDaysChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.extremeHotDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.extremeHotDaysChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onVeryExtremeHotDaysChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.veryExtremeHotDays.instance = ec;
        }
        this.datapointsClimateChartService.veryExtremeHotDaysService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onVeryExtremeHotDaysScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.veryExtremeHotDaysScore.instance = ec;
        }
        this.datapointsClimateChartService.veryExtremeHotDaysScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onVeryExtremeHotDaysChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.veryExtremeHotDaysChange.instance = ec;
        }
        this.datapointsClimateChartService.veryExtremeHotDaysChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePr.instance = ec;
        }
        this.datapointsClimateChartService.climatePrService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrScore.instance = ec;
        }
        this.datapointsClimateChartService.climatePrScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrChange.instance = ec;
        }
        this.datapointsClimateChartService.climatePrChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateCddChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateCdd.instance = ec;
        }
        this.datapointsClimateChartService.climateCddService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateCddScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateCddScore.instance = ec;
        }
        this.datapointsClimateChartService.climateCddScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateCddChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateCddChange.instance = ec;
        }
        this.datapointsClimateChartService.climateCddChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx1dayChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx1day.instance = ec;
        }
        this.datapointsClimateChartService.climateRx1dayService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx1dayScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx1dayScore.instance = ec;
        }
        this.datapointsClimateChartService.climateRx1dayScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx1dayChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx1dayChange.instance = ec;
        }
        this.datapointsClimateChartService.climateRx1dayChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx5dayChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx5day.instance = ec;
        }
        this.datapointsClimateChartService.climateRx5dayService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx5dayScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx5dayScore.instance = ec;
        }
        this.datapointsClimateChartService.climateRx5dayScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateRx5dayChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateRx5dayChange.instance = ec;
        }
        this.datapointsClimateChartService.climateRx5dayChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrsnChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrsn.instance = ec;
        }
        this.datapointsClimateChartService.climatePrsnService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrsnScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrsnScore.instance = ec;
        }
        this.datapointsClimateChartService.climatePrsnScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimatePrsnChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climatePrsnChange.instance = ec;
        }
        this.datapointsClimateChartService.climatePrsnChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSstChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSst.instance = ec;
        }
        this.datapointsClimateChartService.climateSstService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSstScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSstScore.instance = ec;
        }
        this.datapointsClimateChartService.climateSstScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSstChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSstChange.instance = ec;
        }
        this.datapointsClimateChartService.climateSstChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSfcWindChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSfcWind.instance = ec;
        }
        this.datapointsClimateChartService.climateSfcWindService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSfcWindScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSfcWindScore.instance = ec;
        }
        this.datapointsClimateChartService.climateSfcWindScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSfcWindChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSfcWindChange.instance = ec;
        }
        this.datapointsClimateChartService.climateSfcWindChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTrChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTr.instance = ec;
        }
        this.datapointsClimateChartService.climateTrService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTrScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTrScore.instance = ec;
        }
        this.datapointsClimateChartService.climateTrScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateTrChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTrChange.instance = ec;
        }
        this.datapointsClimateChartService.climateTrChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSlrChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlr.instance = ec;
        }
        this.datapointsClimateChartService.climateSlrService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSlrScoreChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlrScore.instance = ec;
        }
        this.datapointsClimateChartService.climateSlrScoreService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    onClimateSlrChangeChartInit(ec) {
        if(!isUndefined(ec)) {
            this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlrChange.instance = ec;
        }
        this.datapointsClimateChartService.climateSlrChangeService.emitAddressChartEvent(ec);
        this.datapointsClimateChartService.showLoading(ec);
    }

    setClimatologyTab(tab: 'CLIMATOLOGY' | 'CHANGE' | 'RISK_SCORING' | 'REGION' | 'CONSOLIDATED_RISK_SCORE') {
        this.climatologyActiveTab = tab;

        if (tab === 'CONSOLIDATED_RISK_SCORE') {
            this.loadInstantCalculationOptions();
        }

        setTimeout(() => {
            // Re-subscribe to any charts that have permissions but aren't initialized
            this.datapointsClimateChartService.resubscribeClimatologyChartsIfNeeded(
                this.location, 
                this.datasetID, 
                false
            );
            this.cd.detectChanges();

            const instances: any[] = [];

            if (tab === 'CLIMATOLOGY') {
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDays.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txx.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTr.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlr.instance);
            } else if (tab === 'CHANGE') {
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.spi6Change.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDaysChange.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTrChange.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlrChange.instance);
            } else if (tab === 'RISK_SCORING') {
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.coolingDegreeDaysScore.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.txxScore.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.spi6Score.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateTrScore.instance);
                instances.push(this.datapointsClimateChartService.chartGraphicsConfiguration.graphType.climateSlrScore.instance);
            } else if (tab === 'REGION') {
                this.regionCharts.forEach(item => instances.push(item.instance));
            } else if (tab === 'CONSOLIDATED_RISK_SCORE') {
                instances.push(this.instantChartItem?.instance);
            }

            instances.forEach(instance => {
                if (instance && typeof instance.resize === 'function') {
                    instance.resize();
                }
            });
        }, 0);
    }

    ngOnInit() {
        this.dataPointsServiceState.emitOnLocationProfileInit();
        this.currentPinAddress.subscribe(response => {
            this.address = response;
        });

        // Tracked for the same reason as the dropdown subscription above: untracked, a stacked-up
        // handler would re-fire the external fetches once per past instance of this panel.
        this.subscriptions.add(
        this.dataPointsServiceState.getExternalOverlaySelection().subscribe((selectedValue) => {
        /*    if(selectedValue == TENSORFLIGHT_ARRAY[0] && this.dataPointsServiceState.externalCallCount === 0) {
                this.dataPointsServiceState.externalCallCount = 1;
                this.tensorflightFieldsMetaData = [];
                this.cd.detectChanges();
                this.fetchTensorFlightAddressProfileData();
            } */

            if (selectedValue == PRECISELY_BUILDING_ARRAY[0] && this.dataPointsServiceState.externalCallCount === 0) {
                this.dataPointsServiceState.externalCallCount = 1;
                this.preciselyFieldsMetaData = [];
                this.cd.detectChanges();
                this.fetchPreciselyBuildingAddressProfileData();
            }

            if(selectedValue == MUNICHRE_ARRAY[0] && this.dataPointsServiceState.externalCallCount === 0) {
                this.dataPointsServiceState.externalCallCount = 1;
                this.fetchMunichReAddressProfileData();
            }

            if(selectedValue == PRECISELY_CRIME_ARRAY[0] && this.dataPointsServiceState.externalCallCount === 0) {
                this.dataPointsServiceState.externalCallCount = 1;
                this.fetchPreciselyCrimeAddressProfileData();
            }

            if(selectedValue == PRECISELY_WILDFIRE_RISK_ARRAY[0] && this.dataPointsServiceState.externalCallCount === 0) {
                this.dataPointsServiceState.externalCallCount = 1;
                this.fetchPreciselyWildfireRiskAddressProfileData();
            }
        }));
    }

    setLocation(data: {address: Point, externalPOIMenuItems: TessadataDataset[], externalPOIDatasetsStructures: TessadataDatasetStructure[]}) {
        // Prefer the address the user actually chose from search. Reverse geocoding the pin is the
        // fallback for a pin that was dragged or entered as coordinates, where nothing better
        // exists - but it answers with the nearest feature, so for a chosen address it replaces
        // "123 William St" with "Fulton St" and the overlays then describe a different block.
        const chosenAddress = this.mapStateService.selectedPlaceAddress;
        if (chosenAddress) {
            this.mapStateService.updateCurrentPinAddress(chosenAddress);
        } else {
            this.geoCoderService.reverseGeocoding(data.address)
                .subscribe(currentPinAddress => this.mapStateService.updateCurrentPinAddress(currentPinAddress));
        }
        this.aerisFetch(data.address);
        this.testdataInputParameters = {address: data.address, tessadataPOIDatasets: data.externalPOIMenuItems, tessadataPOIDatasetsStructures: data.externalPOIDatasetsStructures};
        this.fetchClosestPOI();
        this.location = data.address;
        this.isLoading = true;
        this.cd.detectChanges();
        this._dropdownSelectedValue = this.locationProfile.EXTERNAL;
        // A new search means any Precisely data and polygon on screen belong to the previous
        // address. Cleared here because this assignment bypasses the dropdown subject that normally
        // drives updateAddressProfilePolygons.
        this.preciselyCrimeFieldsWithValues = [];
        this.profilePolygonService.clearPreciselyCrimeBoundary();
        // The instant calculation was run for the previous address, so it starts over here.
        this.clearInstantResult();
        this.instantSelectedProfileId = null;
        this.instantIndicatorValues = {};
        this.profilePolygonService.clearPreciselyWildfireRiskBoundary();
        this.drawPreciselyPolgon("");
        this.selectedAddressPoint = data.address;
        this.prepareClimateCharts(data.address);
        this.loadBioclimaticRegion(data.address);
        const accountId = this.route.snapshot.paramMap.get("accountId");

        this.tessadataService
            .fetchLocationProfile(data.address.y, data.address.x, accountId)
            .pipe(
                tap(locationDetails => this.locationDetails = locationDetails),
                map(locationDetails => locationDetails.datasets.map(dataset => dataset.datasetId)),
                mergeMap(datasetIds => datasetIds.length ? this.tessadataService.fetchDatasetsStructures( this.datasetID , datasetIds) : of(null))
            )
            .subscribe((response: TessadataDatasetStructure[] | null) => {
                if (response) {
                    this.mapDatasetFieldLabels(response);
                }
                this.requestFailed = false;
                this.isLoading = false;
                setTimeout(() => {
                    if (this.locationDetails) {
                        this.prepareNRICards();
                    }
                }, 2000);
                this.cd.detectChanges();
            }, () => {
                this.requestFailed = true;
                this.isLoading = false;
                this.cd.detectChanges();
            });
    }

    private mapDatasetFieldLabels(labelDatasets: TessadataDatasetStructure[]) {
        this.locationDetails.datasets.forEach((dataset: TessadataFieldsValues) => {
            if (dataset.fields.length) {
                const labelDataset = labelDatasets.find(labelDataset => labelDataset.datasetId === dataset.datasetId);

                dataset.fields.forEach(field => {
                    const labelField = labelDataset.fields.find(labelField => labelField.fieldId === field.id);
                    if (!isNullOrUndefined(labelField)) {
                        field.label = labelField.fieldLabel;
                    }
                });
            }
        });
    }

    onExpandedClick(expanded?: boolean) {
        this.isExpanded = (expanded !== undefined) ? expanded : !this.isExpanded;

        if (!expanded) {
            this.dataPointsServiceState.emitOnAddressLocationProfileClose();
        }
    }

    downloadLocationProfile($event) {
        $event.preventDefault();
        if (!this.locationDetails || !this.currentPinAddress) {
            return;
        }
        let address: any;
        this.currentPinAddress.subscribe(response => {
            address = response;
        });

        let distanceInM = ComputationUtils.getDistanceInMeters(this.tessadataPOIDistance, this.tessadataPOIDistanceUnit);
        const poiClosestFilter: PoiClosestFilter = {
            latitude: this.testdataInputParameters.address.y,
            longitude: this.testdataInputParameters.address.x,
            externalDatasetId: this.tessadataPOIDataset.datasetId,
            distanceInMeters: distanceInM,
            distanceUnit: this.tessadataPOIDistanceUnit,
            limit: this.tessadataPOILimit
        };
        const filterIds = this.filterIds();
     //   filterIds.push(ExternalDataFetchingAPIKeys.TENSORFLIGHT)
        filterIds.push(ExternalDataFetchingAPIKeys.MUNICHRE)
        filterIds.push(ExternalDataFetchingAPIKeys.PRECISELY_CRIME)
        filterIds.push(ExternalDataFetchingAPIKeys.PRECISELY_WILDFIRE_RISK)
        filterIds.push(ExternalDataFetchingAPIKeys.PRECISELY_BUILDING)
        this.downloadService.downloadExternalDataForAddress(this.location, this.datasetID, address, filterIds, poiClosestFilter)
            .subscribe(response => AttachmentUtils.downloadFileWithName(response, 'Address Profile.xlsx'),
                error => this.notifService.error('Something went wrong during download'));
        // this.currentPinAddress.pipe(
        //     switchMap(address => this.downloadService.downloadExternalDataForAddress(this.location, address, this.filterIds())),
        //     tap(response => AttachmentUtils.downloadFileWithName(response, 'Address Profile.xlsx'))
        // ).subscribe();
    }

    filterIds() {
        return this.locationDetails.datasets.reduce(function(ids, obj){
            if(!['25', '26'].includes(obj.datasetId)){
                ids.push(obj.datasetId);
            }
            return ids;
        }, []);
    }

    onClickCoordinates() {
        this.notifService.success('Full Coordinates Copied');
        window.navigator.clipboard.writeText(this.location.y + ',' + this.location.x);
    }

    ngOnDestroy() {
        this.dataPointsServiceState.emitOnLocationProfileDestroyed();
        this.datapointsClimateChartService.unsubscribeAddressChartInstances();
        // Held on a service shared with the next panel, so a closed address's Region charts must
        // not be downloaded from it.
        this.regionRequest?.unsubscribe();
        this.bioclimaticRegionRequest?.unsubscribe();
        this.datapointsClimateChartService.regionGraphs = [];
        this.datapointsClimateChartService.bioclimaticRegion = null;
        this.datapointsClimateChartService.regionDownloadPayload = {};
        // The instant result is held on a service shared with the location panel, so leaving it
        // set would export this address's calculation from whichever panel opens next.
        this.datapointsClimateChartService.consolidatedRiskScoreInstantChart = null;
        // The boundary belongs to this panel, so closing it should take the polygon off the map.
        this.profilePolygonService.clearPreciselyCrimeBoundary();
        this.profilePolygonService.clearPreciselyWildfireRiskBoundary();
        // Without this, every subscription above outlives the panel and runs again - once per past
        // instance - the next time the shared subjects emit.
        this.subscriptions.unsubscribe();
    }

    avoidDatasets(datasetId) {
        return  !['25', '26'].includes(datasetId);
    }

    prepareClimateCharts(address: Point) {
        this.datapointsClimateChartService.subscribeAddressChartInstances(address, this.datasetID);
        this.datapointsClimateChartService.checkClimatePermissions(this.climateOverlayPermission, this.datasetID);
    }

    prepareClimatologyCharts(address: Point) {
        this.datapointsClimateChartService.subscribeAddressClimatologyChartInstances(address, this.datasetID, this.climateOverlayPermission, this.cd);
        this.datapointsClimateChartService.checkClimatologyPermissions(
            this.climateOverlayPermission, 
            this.datasetID,
            () => {
                this.setClimatologyTab('RISK_SCORING');
            }
        );
        this.prepareRegionCharts(address);
    }

    /**
     * Loads the Region tab: one chart per indicator for the bioclimatic zone the address falls
     * in. Loaded with the rest of Climate Change rather than when the tab opens, so Download Data
     * and Download Chart carry it either way.
     */
    private prepareRegionCharts(address: Point) {
        this.regionRequest?.unsubscribe();
        this.regionCharts = [];
        this.datapointsClimateChartService.regionGraphs = [];
        this.datapointsClimateChartService.regionDownloadPayload = {};

        // Whether the tab shows is decided when the profile opens (loadBioclimaticRegion), so it is
        // there with the other tabs; the charts load inside it. With Bioclimatic not assigned the
        // backend answers with no charts.
        this.regionLoading = true;
        this.cd.markForCheck();
        this.regionRequest = this.climateService.fetchBioclimaticZonesByLocation(address, this.datasetID)
            .pipe(catchError(() => of([] as ClimateChart[])))
            .subscribe(charts => {
                this.regionLoading = false;
                this.regionCharts = (charts || []).map(chart => toRegionChartItem(chart));
                (charts || []).forEach((chart, index) => {
                    this.datapointsClimateChartService.regionDownloadPayload[chart.indicatorCode || `region${index}`] = chart;
                });
                this.cd.detectChanges();
            });
    }

    private loadBioclimaticRegion(address: Point) {
        this.bioclimaticRegionRequest?.unsubscribe();
        this.bioclimaticRegion = null;
        this.datapointsClimateChartService.bioclimaticRegion = null;
        this.bioclimaticZonesEnabled = false;
        this.bioclimaticRegionRequest = this.climateService
            .fetchBioclimaticRegionByLocation(address, this.datasetID)
            .pipe(catchError(() => of(null)))
            .subscribe(region => {
                this.bioclimaticRegion = region?.region ? region : null;
                this.datapointsClimateChartService.bioclimaticRegion = this.bioclimaticRegion;
                // A zone comes back only when Bioclimatic is assigned, so it also decides the Region tab.
                this.bioclimaticZonesEnabled = !!this.bioclimaticRegion;
                if (!this.bioclimaticZonesEnabled && this.climatologyActiveTab === 'REGION') {
                    this.setClimatologyTab('RISK_SCORING');
                }
                this.cd.detectChanges();
            });
    }

    onRegionChartInit(ec: any, item: RegionChartItem, index: number) {
        if (isUndefined(ec)) {
            return;
        }
        item.instance = ec;
        keepRegionLevelsBetweenTicks(ec);
        // Indexed rather than pushed, so the PDF keeps the tab's order whichever chart renders first.
        this.datapointsClimateChartService.regionGraphs[index] = { title: item.title, instance: ec };
        setTimeout(() => {
            // The first column holds the zone's region, not a period as in the other climate charts.
            ClimateChartHelper.attachDownloadHandler(ec, item.title, item.fileName, 'Region');
            ec.resize();
        }, 0);
    }

    isExternalDatasets(datasetId) {
        return !['noharm','risk_index_tract'].includes(datasetId);
    }

    aerisFetch(address: Point) {
        this.aerisService.getAerisCredentials().subscribe((value:any) =>{
        let aerisCredentials = Aeris.decodeAerisCredentials(value.aerisClient, value.aerisSecret)

        this.aerisService.fetchLocationProfile(AerisType.CONDITIONS, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.meteorologicalConditionsData = Aeris.computeAerisData(response, '', 0);
            this.meteorologicalConditionsData = this.meteorologicalConditionsData.filter(meteorologicalConditions => {
                return meteorologicalConditions.text !== "" && meteorologicalConditions.value !== "";
            })
        }, (error) => {
            this.meteorologicalConditionsData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.FORECASTS, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.forecastData = Aeris.computeAerisData(response, '', 0);
            this.forecastData = this.forecastData.filter(forecast => {
                return forecast.text !== "" && forecast.value !== "";
            })
        }, (error) => {
            this.forecastData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.AIR_QUALITY, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.airQualityData = Aeris.computeAerisData(response, '', 0);
            this.airQualityData = this.airQualityData.filter(airQuality => {
                return airQuality.text !== "" && airQuality.value !== "";
            })
        }, (error) => {
            this.airQualityData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.TROPICALCYCLONES, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.tropicalCyclonesData = Aeris.computeAerisData(response, '', 0);
            this.tropicalCyclonesData = this.tropicalCyclonesData.filter(tropicalCyclones => {
                return tropicalCyclones.text !== "" && tropicalCyclones.value !== "";
            })
        }, (error) => {
            this.tropicalCyclonesData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.ALERTS, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.alertsData = Aeris.computeAerisData(response, '', 0);
            this.alertsData = this.alertsData.filter(alerts => {
                return alerts.text !== "" && alerts.value !== "";
            })
        }, (error) => {
            this.alertsData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.CONVECTIVE, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.convectiveData = Aeris.computeAerisData(response, '', 0);
            this.convectiveData = this.convectiveData.filter(convective => {
                return convective.text !== "" && convective.value !== "";
            })
        }, (error) => {
            this.convectiveData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.DROUGHTS, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.droughtsData = Aeris.computeAerisData(response, '', 0);
            this.droughtsData = this.droughtsData.filter(droughts => {
                return droughts.text !== "" && droughts.value !== "";
            })
        }, (error) => {
            this.droughtsData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.FIRES_OUTLOOk, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.firesOutlookData = Aeris.computeAerisData(response, '', 0);
            this.firesOutlookData = this.firesOutlookData.filter(firesOutlook => {
                return firesOutlook.text !== "" && firesOutlook.value !== "";
            })
        }, (error) => {
            this.firesOutlookData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.FIRES, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.firesData = Aeris.computeAerisData(response, '', 0);
            this.firesData = this.firesData.filter(fires => {
                return fires.text !== "" && fires.value !== "";
            })
        }, (error) => {
            this.firesData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.PLACES, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.placesData = Aeris.computeAerisData(response, '', 0);
            this.placesData = this.placesData.filter(places => {
                return places.text !== "" && places.value !== "";
            })
        }, (error) => {
            this.placesData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.RIVERS, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.riversData = Aeris.computeAerisData(response, '', 0);
            this.riversData = this.riversData.filter(rivers => {
                return rivers.text !== "" && rivers.value !== "";
            })
        }, (error) => {
            this.riversData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.STORMCELLS, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.stormCellsData = Aeris.computeAerisData(response, '', 0);
            this.stormCellsData = this.stormCellsData.filter(stormCells => {
                return stormCells.text !== "" && stormCells.value !== "";
            })
        }, (error) => {
            this.stormCellsData = [];
        });
        this.aerisService.fetchLocationProfile(AerisType.THREATS, aerisCredentials.aerisClient, aerisCredentials.aerisSecret, address.y, address.x).subscribe((value: any) => {
            const response = value.response;
            this.threatsData = Aeris.computeAerisData(response, '', 0);
            this.threatsData = this.threatsData.filter(threats => {
                return threats.text !== "" && threats.value !== "";
            })
        }, (error) => {
            this.threatsData = [];
        });
    });
    }

    /**
     * Download Chart only applies to the two tabs that carry charts. Checked on the click as well
     * as through [disabled]: mat-menu-item on a div styles it as disabled without making it so,
     * so the handler would otherwise fire from a greyed-out item.
     */
    get canDownloadChart(): boolean {
        return this._dropdownSelectedValue === this.locationProfile.CLIMATE
            || this._dropdownSelectedValue === this.locationProfile.CLIMATE_CHANGE;
    }

    downloadAdressProfileChart() {
        const addressDetails = {
            address: this.address,
            yAxis: this.location.y.toFixed(6),
            xAxis: this.location.x.toFixed(6)
        }
        Climate.downloadOverlayProfileChart(this.datapointsClimateChartService, this.notifService, 'addressProfileClimateChart', null, addressDetails, this._dropdownSelectedValue);
    }

    fetchClosestPOI(isSubmitCall: boolean = false) {
        if (this.tessadataEnabled) {
            if (!isSubmitCall) {
                this.tessadataPOIDataset = this.testdataInputParameters.tessadataPOIDatasets[0];
            }
            let distanceInM = ComputationUtils.getDistanceInMeters(this.tessadataPOIDistance, this.tessadataPOIDistanceUnit);
            this.tessadataPOISubmittedDistanceUnit = this.tessadataPOIDistanceUnit;
            const poiClosestFilter: PoiClosestFilter = {
                latitude: this.testdataInputParameters.address.y,
                longitude: this.testdataInputParameters.address.x,
                externalDatasetId: this.tessadataPOIDataset.datasetId,
                distanceInMeters: distanceInM,
                distanceUnit: this.tessadataPOIDistanceUnit,
                limit: this.tessadataPOILimit
            };
            //this.poiClosestSubmittedFilter.emit(poiClosestFilter);
            this.tessadataService.fetchClosestPOIDetails(poiClosestFilter).subscribe(
                locationDetails => {
                    this.tessadataPOIDetails = locationDetails.datasets;
                    if (this.tessadataPOIDetails.length) {
                        let tessadataDatasetStructure = this.testdataInputParameters.tessadataPOIDatasetsStructures.find(structure => structure.datasetId === this.tessadataPOIDetails[0].datasetId);
                        this.tessadataPOIDetails.forEach(poi => poi.fields.forEach(field => {
                            let tessadataField = tessadataDatasetStructure.fields.find(f => f.fieldId === field.id);
                            field.label = tessadataField.fieldLabel;
                            field.type = tessadataField.fieldType;
                            if (field.label === 'Distance') {
                                field.value = field.value ? String(ComputationUtils.getDistanceInUnit(Number(field.value), this.tessadataPOIDistanceUnit)) : '';
                            }
                        }));
                    }
                   this.cd.detectChanges();
                }
            );
        }
    }

    fetchPreciselyBuildingAddressProfileData() {
        const accountId = +this.route.snapshot.paramMap.get("accountId");
        const preciselyBuildingStructureObservable = this.tessadataService.fetchDatasetsStructures(this.datasetID, [ExternalDataFetchingAPIKeys.PRECISELY_BUILDING]);
        const preciselyBuildingAddressProfileData = this.tessadataService.getLoggedData(this.dataPointsServiceState.activeSearchLocation.y, this.dataPointsServiceState.activeSearchLocation.x, ExternalDataFetchingAPIKeys.PRECISELY_BUILDING);

        forkJoin({
            preciselyStructure:preciselyBuildingStructureObservable,
            preciselyData:preciselyBuildingAddressProfileData
        }).subscribe({
            next: (result) => {
                this.preciselyFieldsMetaData = result?.preciselyStructure[0]?.fields || [];
                const preciselyData = result?.preciselyData?.datasets[0] || null;
                const preciselyStructure = result?.preciselyStructure[0] || null;

                if(!preciselyData){
                    this.openConfirmationDialogForExternalDatasets(accountId, ExternalDataFetchingAPIKeys.PRECISELY_BUILDING)
                } else {
                    this.preparePreciselyDataForAddressProfilePanel(preciselyData, this.preciselyFieldsMetaData)
                }
            },
            error: (error) => {
                console.error('[COPE] fetch failed', error);
                this.requestFailed = true;
                this.cd.detectChanges();
            }
        });
    }

    preparePreciselyDataForAddressProfilePanel(preciselyData, preciselyFieldsMetaData) {
        // Geometry is carried in the payload for the map only - it is not one of the dataset's
        // fields, so it has no label and would render as an unnamed row of raw coordinates.
        const fields = preciselyData.fields.filter(
            (field) => !(field.id && field.id.endsWith(PRECISELY_BUILDING_GEOMETRY_KEY)));
        this.dataPointsServiceState.preciselyFieldsWithValues = this.combineFieldMetaDataAndFieldValue(fields, preciselyFieldsMetaData);
        // Ids arrive unprefixed in the see-info payload (geometry_coordinates) and prefixed on a
        // datapoint; endsWith covers both. A miss is ordinary - Precisely has no footprint for
        // plenty of addresses - so it clears rather than throwing on an undefined field.
        const preciselyBuildingAddressProfilePolygon = preciselyData.fields
            .find((field) => field.id && field.id.endsWith(PRECISELY_BUILDING_GEOMETRY_KEY));

        if (preciselyBuildingAddressProfilePolygon && preciselyBuildingAddressProfilePolygon.value) {
            this.drawPreciselyPolgon(preciselyBuildingAddressProfilePolygon.value);
        } else {
            this.drawPreciselyPolgon("");
        }

        this.activeProfile = 'Precisely';
        this.dataPointsServiceState.emitDropDownValue(this.EMPTY_PROFILE);
        this.cd.detectChanges();
        setTimeout(() => {
            this.dataPointsServiceState.emitDropDownValue(PRECISELY_BUILDING_ARRAY[0]);
            this.cd.detectChanges();
        }, 0);
    }

 /*   fetchTensorFlightAddressProfileData() {
        const accountId = +this.route.snapshot.paramMap.get("accountId");

        const tensorflightStructureObservable = this.tessadataService.fetchDatasetsStructures(this.datasetID, [ExternalDataFetchingAPIKeys.TENSORFLIGHT]);
        const tensorflightAdddressProfileData = this.tessadataService.getLoggedData(this.dataPointsServiceState.activeSearchLocation.y, this.dataPointsServiceState.activeSearchLocation.x, ExternalDataFetchingAPIKeys.TENSORFLIGHT);

        forkJoin({
            tensorflightStructure: tensorflightStructureObservable,
            tensorflightData: tensorflightAdddressProfileData
        }).subscribe({
            next: (result) => {
                this.tensorflightFieldsMetaData = result?.tensorflightStructure[0]?.fields || [];
                const tensorflightData = result?.tensorflightData?.datasets[0] || null;

                if(!tensorflightData){
                    this.openConfirmationDialogForExternalDatasets(accountId, ExternalDataFetchingAPIKeys.TENSORFLIGHT)
                } else {
                    this.prepareDataTensorflightForAddressProfilePanel(tensorflightData, this.tensorflightFieldsMetaData);
                }

            },
            error: (err) => {
                console.error('Error:', err);
            }
        });


    }

    prepareDataTensorflightForAddressProfilePanel(tensorflightData, tensorflightMetaFields) {
        const fields = tensorflightData.fields.filter((field) => field.id !== TENSORFLIGHT_POLYGON_DATA_KEY);
        this.dataPointsServiceState.tensorflightFieldsWithValues = this.combineFieldMetaDataAndFieldValue(fields, tensorflightMetaFields);
        const tensorflightAddressProfilePolygon = tensorflightData.fields.find((field) => field.id === TENSORFLIGHT_POLYGON_DATA_KEY);

        if(tensorflightAddressProfilePolygon.value){
            this.drawTensorflightPolgon(tensorflightAddressProfilePolygon.value);
        }

        this.activeProfile = 'Tensorflight';
        this.dataPointsServiceState.emitDropDownValue(this.EMPTY_PROFILE);
        this.cd.detectChanges();
        setTimeout(() => {
            this.dataPointsServiceState.emitDropDownValue(TENSORFLIGHT_ARRAY[0]);
            this.cd.detectChanges();
        }, 0);
    }
*/
    combineFieldMetaDataAndFieldValue(fields, metaFields): any[] {
        const transformedFields = fields.map((field) => {
            const metaField = metaFields.find((metaField) => metaField.fieldId === field.id) || {};
            return {
                ...metaField,
                ...field
            }
        })
        return transformedFields;
    }

    formatExternalDataFieldValue(field) {
        if(field.fieldType === DatasetFieldType.NUMERIC){
            const numericValue = parseFloat(field.value);
            const roundedValue = Math.round(numericValue * 100) / 100;
            return roundedValue.toFixed(2);
        }
        return field.value;
    }

    openConfirmationDialogForExternalDatasets(accountId, datasetId) {
        const dialogRef = this.dialog.open(DialogComponent, {
            data: new DialogModel(
                "Confirm Action",
                `Are you sure you want to fetch data?`
            ),
        });
        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe((dialogResult) => {
                if (dialogResult) {
                    this.tessadataService.fetchExternalLogData(accountId, this.dataPointsServiceState.activeSearchLocation.y, this.dataPointsServiceState.activeSearchLocation.x, datasetId, this.address).subscribe((response) => {
                        // The backend answers a location it holds no data for with an empty body,
                        // not an empty payload, so response itself is null here. Reading .datasets
                        // off it threw inside the subscriber and the panel simply stopped.
                        const data = response?.datasets?.[0] || null;
                        if (!data) {
                            this.clearExternalDatasetCard(datasetId);
                            return;
                        }

                        this.cd.detectChanges();
                     //   if(data && datasetId == ExternalDataFetchingAPIKeys.TENSORFLIGHT){
                     //       this.prepareDataTensorflightForAddressProfilePanel(data, this.tensorflightFieldsMetaData);
                     //   }
                        if(data && datasetId == ExternalDataFetchingAPIKeys.MUNICHRE){
                            this.prepareMunichreDataForAddressProfilePanel(data, this.munichreFieldsMetaData);
                        }
                        if(data && datasetId == ExternalDataFetchingAPIKeys.PRECISELY_BUILDING){
                            this.preparePreciselyDataForAddressProfilePanel(data, this.preciselyFieldsMetaData);
                        }
                        if(data && datasetId == ExternalDataFetchingAPIKeys.PRECISELY_CRIME){
                            this.preparePreciselyCrimeDataForAddressProfilePanel(data, this.preciselyCrimeFieldsMetaData);
                        }
                        if(data && datasetId == ExternalDataFetchingAPIKeys.PRECISELY_WILDFIRE_RISK){
                            this.preparePreciselyWildfireRiskDataForAddressProfilePanel(data, this.preciselyWildfireRiskFieldsMetaData);
                        }
                    });
                }
            });
    }

    private clearExternalDatasetCard(datasetId) {
        if (datasetId == ExternalDataFetchingAPIKeys.MUNICHRE) {
            this.dataPointsServiceState.munichreFieldsWithValues = [];
        }
        if (datasetId == ExternalDataFetchingAPIKeys.PRECISELY_BUILDING) {
            this.dataPointsServiceState.preciselyFieldsWithValues = [];
            this.drawPreciselyPolgon("");
        }
        if (datasetId == ExternalDataFetchingAPIKeys.PRECISELY_CRIME) {
            this.preciselyCrimeFieldsWithValues = [];
            this.profilePolygonService.clearPreciselyCrimeBoundary();
        }
        if (datasetId == ExternalDataFetchingAPIKeys.PRECISELY_WILDFIRE_RISK) {
            this.preciselyWildfireRiskFieldsWithValues = [];
            this.profilePolygonService.clearPreciselyWildfireRiskBoundary();
        }
        this.cd.detectChanges();
    }

    drawPreciselyPolgon(preciselyAddressProfilePolygon) {
        this.dataPointsServiceState.emitOnPreciselyAddressProfilePolygonFetch(preciselyAddressProfilePolygon);
    }

    /**
     * Leave only the selected Precisely dataset's polygon on the map.
     *
     * Each dataset draws through a different mechanism - COPE through the
     * emitOnPreciselyAddressProfilePolygonFetch subject, Crime through ProfilePolygonService - and
     * each only ever knew how to clear its own. Switching COPE -> Crime therefore added the block
     * group on top of the footprint instead of replacing it. Clearing every non-selected one from
     * a single place is what keeps that from returning as more datasets are added.
     *
     * Only ever clears - drawing is driven from each dataset's data prep, once, when the data it
     * depends on has actually arrived. Fetching from here as well produced two requests per
     * selection: this fires immediately on the dropdown change, while the panel separately re-runs
     * its see-info fetch (side-panel.component.ts resets externalCallCount on every dropdown
     * change) and emits the profile a second time when that returns.
     *
     * EMPTY_PROFILE is skipped because the data prep emits it purely to force the card to
     * re-render; treating it as "switched away" would clear and immediately redraw the polygon,
     * which is what made it blink.
     */
    private updateAddressProfilePolygons() {
        if (this._dropdownSelectedValue === this.EMPTY_PROFILE) {
            return;
        }
        if (this._dropdownSelectedValue !== this.locationProfile.PRECISELY_BUILDING) {
            // "" is how this subject signals a clear - the map treats a falsy payload as remove.
            this.drawPreciselyPolgon("");
        }
        if (this._dropdownSelectedValue !== this.locationProfile.PRECISELY_CRIME) {
            this.profilePolygonService.clearPreciselyCrimeBoundary();
        }
        if (this._dropdownSelectedValue !== this.locationProfile.PRECISELY_WILDFIRE_RISK) {
            this.profilePolygonService.clearPreciselyWildfireRiskBoundary();
        }
    }

    /**
     * Draw the searched address's Census block group. The lookup itself is shared with the
     * datapoint Location Profile - see ProfilePolygonService.loadPreciselyCrimeBoundary.
     */
    // The fireshed was already stored when the see-info fetch ran, so this reads it back rather
    // than buying the same record again - a wildfire record is the dearest call we make.
    private drawPreciselyWildfireRiskBoundary() {
        const location = this.dataPointsServiceState.activeSearchLocation;
        if (!location) {
            this.profilePolygonService.clearPolygon(PRECISELY_WILDFIRE_RISK_ARRAY[0]);
            return;
        }

        this.datasetService.fetchPreciselyWildfirePolygonByLocation({
            lat: location.y,
            lng: location.x
        }).subscribe({
            next: (response) => {
                this.profilePolygonService.setPolygon(PRECISELY_WILDFIRE_RISK_ARRAY[0], response ? response.polygonData : null);
                this.profilePolygonService.requestZoom(PRECISELY_WILDFIRE_RISK_ARRAY[0]);
                this.cd.detectChanges();
            },
            error: () => {
                this.profilePolygonService.clearPolygon(PRECISELY_WILDFIRE_RISK_ARRAY[0]);
            }
        });
    }

    private drawPreciselyCrimeBoundary() {
        const blockGroupCode = this.getPreciselyCrimeFieldValue('block_group_code');
        if (!blockGroupCode) {
            // No identifier to look the boundary up by - ordinary for an address Precisely holds
            // no crime data for. Clearing rather than requesting avoids a call that cannot succeed.
            this.profilePolygonService.clearPreciselyCrimeBoundary();
            return;
        }

        const location = this.dataPointsServiceState.activeSearchLocation;
        this.profilePolygonService.loadPreciselyCrimeBoundary(
            blockGroupCode,
            location ? location.y : undefined,
            location ? location.x : undefined,
            this.getPreciselyCrimeFieldValue('vintage'),
            () => this.cd.detectChanges()
        );
    }

    /**
     * A value from the fetched crime fields. Ids arrive unprefixed in the see-info payload
     * (block_group_code, vintage); endsWith keeps this working if they are ever prefixed.
     */
    private getPreciselyCrimeFieldValue(fieldId: string): string {
        const field = this.preciselyCrimeFieldsWithValues?.find(item => item.id?.endsWith(fieldId));
        return field ? field.value : null;
    }

  //  drawTensorflightPolgon(tensorflightAddressProfilePolygon) {
    //    this.dataPointsServiceState.emitOnTensorflightAddressProfilePolygonFetch(tensorflightAddressProfilePolygon);
    //}

    isFieldValueValid(value) {
        if(value === null || value === undefined || value === "null"){
            return false
        }
        return true
    }

    fetchMunichReAddressProfileData() {
        this.dataPointsServiceState.dataSource = [];
        this.munichreFieldsMetaData = [];
        this.dataPointsServiceState.munichreFieldsWithValues = [];
        this.hazardScores = null;
        const accountId = +this.route.snapshot.paramMap.get("accountId");
        const munichreStructureObservable = this.tessadataService.fetchDatasetsStructures(this.datasetID, [ExternalDataFetchingAPIKeys.MUNICHRE]);
        const munichreAdddressProfileData = this.tessadataService.getLoggedData(this.dataPointsServiceState.activeSearchLocation.y, this.dataPointsServiceState.activeSearchLocation.x, ExternalDataFetchingAPIKeys.MUNICHRE);
        this.cd.detectChanges();
        forkJoin({
            munichreStructure: munichreStructureObservable,
            munichreData: munichreAdddressProfileData
        }).subscribe({
            next: (result) => {
                this.munichreFieldsMetaData = result?.munichreStructure[0]?.fields || [];
                const munichreData = result?.munichreData?.datasets[0] || null;

                if(!munichreData){
                    this.openConfirmationDialogForExternalDatasets(accountId, ExternalDataFetchingAPIKeys.MUNICHRE)
                } else {
                    this.prepareMunichreDataForAddressProfilePanel(munichreData, this.munichreFieldsMetaData)
                }

            },
            error: (err) => {
                console.error('Error:', err);
            }
        });
    }

    fetchPreciselyWildfireRiskAddressProfileData() {
        this.preciselyWildfireRiskFieldsMetaData = [];
        this.preciselyWildfireRiskFieldsWithValues = [];
        const accountId = +this.route.snapshot.paramMap.get("accountId");
        const preciselyWildfireRiskStructureObservable = this.tessadataService.fetchDatasetsStructures(this.datasetID, [ExternalDataFetchingAPIKeys.PRECISELY_WILDFIRE_RISK]);
        const preciselyWildfireRiskAddressProfileData = this.tessadataService.getLoggedData(this.dataPointsServiceState.activeSearchLocation.y, this.dataPointsServiceState.activeSearchLocation.x, ExternalDataFetchingAPIKeys.PRECISELY_WILDFIRE_RISK);
        this.cd.detectChanges();
        forkJoin({
            preciselyWildfireRiskStructure: preciselyWildfireRiskStructureObservable,
            preciselyWildfireRiskData: preciselyWildfireRiskAddressProfileData
        }).subscribe({
            next: (result) => {
                this.preciselyWildfireRiskFieldsMetaData = result?.preciselyWildfireRiskStructure[0]?.fields || [];
                const preciselyWildfireRiskData = result?.preciselyWildfireRiskData?.datasets[0] || null;

                if(!preciselyWildfireRiskData){
                    this.openConfirmationDialogForExternalDatasets(accountId, ExternalDataFetchingAPIKeys.PRECISELY_WILDFIRE_RISK)
                } else {
                    this.preparePreciselyWildfireRiskDataForAddressProfilePanel(preciselyWildfireRiskData, this.preciselyWildfireRiskFieldsMetaData)
                }
            },
            error: (err) => {
                console.error('Error:', err);
            }
        });
    }

    preparePreciselyWildfireRiskDataForAddressProfilePanel(preciselyWildfireRiskData, preciselyWildfireRiskMetaFields) {
        this.preciselyWildfireRiskFieldsWithValues = this.combineFieldMetaDataAndFieldValue(preciselyWildfireRiskData.fields, preciselyWildfireRiskMetaFields);

        this.drawPreciselyWildfireRiskBoundary();

        this.activeProfile = 'Precisely Wildfire Risk';
        this.dataPointsServiceState.emitDropDownValue(this.EMPTY_PROFILE);
        this.cd.detectChanges();
        setTimeout(() => {
            this.dataPointsServiceState.emitDropDownValue(PRECISELY_WILDFIRE_RISK_ARRAY[0]);
            this.cd.detectChanges();
        }, 0);
    }

    fetchPreciselyCrimeAddressProfileData() {
        this.preciselyCrimeFieldsMetaData = [];
        this.preciselyCrimeFieldsWithValues = [];
        const accountId = +this.route.snapshot.paramMap.get("accountId");
        const preciselyCrimeStructureObservable = this.tessadataService.fetchDatasetsStructures(this.datasetID, [ExternalDataFetchingAPIKeys.PRECISELY_CRIME]);
        const preciselyCrimeAddressProfileData = this.tessadataService.getLoggedData(this.dataPointsServiceState.activeSearchLocation.y, this.dataPointsServiceState.activeSearchLocation.x, ExternalDataFetchingAPIKeys.PRECISELY_CRIME);
        this.cd.detectChanges();
        forkJoin({
            preciselyCrimeStructure: preciselyCrimeStructureObservable,
            preciselyCrimeData: preciselyCrimeAddressProfileData
        }).subscribe({
            next: (result) => {
                this.preciselyCrimeFieldsMetaData = result?.preciselyCrimeStructure[0]?.fields || [];
                const preciselyCrimeData = result?.preciselyCrimeData?.datasets[0] || null;

                if(!preciselyCrimeData){
                    this.openConfirmationDialogForExternalDatasets(accountId, ExternalDataFetchingAPIKeys.PRECISELY_CRIME)
                } else {
                    this.preparePreciselyCrimeDataForAddressProfilePanel(preciselyCrimeData, this.preciselyCrimeFieldsMetaData)
                }
            },
            error: (err) => {
                console.error('Error:', err);
            }
        });
    }

    preparePreciselyCrimeDataForAddressProfilePanel(preciselyCrimeData, preciselyCrimeMetaFields) {
        // Every field the backend sends, in its order, labelled from the dataset structure - the
        // same shape the other external cards use. Block group code and crime data vintage come
        // through as ordinary rows, and a field added server-side appears without a change here.
        this.preciselyCrimeFieldsWithValues = this.combineFieldMetaDataAndFieldValue(preciselyCrimeData.fields, preciselyCrimeMetaFields);

        // Drawn here rather than from the dropdown handler: this is the one point where the block
        // group code is known to be loaded, and it runs once per selection.
        this.drawPreciselyCrimeBoundary();

        this.activeProfile = 'Precisely Crime';
        this.dataPointsServiceState.emitDropDownValue(this.EMPTY_PROFILE);
        this.cd.detectChanges();
        setTimeout(() => {
            this.dataPointsServiceState.emitDropDownValue(PRECISELY_CRIME_ARRAY[0]);
            this.cd.detectChanges();
        }, 0);
    }

    prepareMunichreDataForAddressProfilePanel(munichreData, munichreMetaFields) {
        this.hazardScores = MinuchRe.HazardScoresElements();
        const fields = munichreData.fields;
        this.dataPointsServiceState.munichreFieldsWithValues = this.combineFieldMetaDataAndFieldValue(fields, munichreMetaFields);;

        this.dataPointsServiceState.munichreFieldsWithValues.forEach(field =>{
            this.hazardScores.forEach(hazardScore => {
                if (hazardScore.id.replace('munichre_hazards_', '') === field.fieldId) {
                    hazardScore.values.forEach((item) => {
                        // Iterate over the keys of each object
                        Object.keys(item).forEach((key) => {
                            let value = item[key];
                            if(value.value == field.value || (field.value && value.value == parseInt(field.value).toFixed(4).replace(/\.0+$/,''))) {
                                value.isActive = true;
                                value.class = 'progress-bar active';
                                value.tooltip = value.tooltip + value.value;
                            } else {
                                value.tooltip = '';
                            }
                        });
                    });
                }
            });

        })
        this.dataPointsServiceState.dataSource = this.hazardScores;
        this.dataPointsServiceState.riskDataSource = this.riskScores;

        this.activeProfile = 'Munich Re';
        this.dataPointsServiceState.emitDropDownValue(this.EMPTY_PROFILE);
        this.cd.detectChanges();
        setTimeout(() => {
            this.dataPointsServiceState.emitDropDownValue(MUNICHRE_ARRAY[0]);
            this.cd.detectChanges();
        }, 0);
    }

    isMunicReDataPresent() {
        return this.dataPointsServiceState.munichreFieldsWithValues?.length && this.dataPointsServiceState.dataSource?.length && this.dataPointsServiceState.riskDataSource?.length;
    }

    getPointerPositionForSeeInfo(element:any){
        const field = this.dataPointsServiceState.munichreFieldsWithValues.find(field => field.fieldId === element.values[1].id.replace('munichre_hazards_', ''));
        if(field !== undefined){
            return MinuchRe.getPointerPosition(field.value);
        }
    }

    getTooltipTextForSeeInfo(element: any): string {
        const fieldRiskScore = this.dataPointsServiceState.munichreFieldsWithValues.find(field => field.fieldId === element.values[0].id.replace('munichre_hazards_', ''));
        const fieldRiskIndex = this.dataPointsServiceState.munichreFieldsWithValues.find(field => field.fieldId === element.values[1].id.replace('munichre_hazards_', ''));

        if (fieldRiskIndex !== undefined && fieldRiskScore !== undefined) {
            return MinuchRe.getTooltipText(fieldRiskIndex.value, fieldRiskScore.value);
        } else if (fieldRiskScore === undefined && fieldRiskIndex !== undefined) {
            return `Risk Score:  - Risk Index: ${fieldRiskIndex.value}`;
        } else if (fieldRiskScore !== undefined && fieldRiskIndex === undefined) {
            return `Risk Score: ${fieldRiskScore.value} - Risk Index: `;
        } else {
            const defaultRiskIndex = 0;
            const defaultRiskScore = "Low";
            return `Risk Score: ${defaultRiskScore} - Risk Index: ${defaultRiskIndex}`;
        }
    }

    downloadMunichReportForSeeInfo() {
        this.subscriptions.add(
            this.downloadService
                .downloadMunichReReportForSeeInfo(this.location.y, this.location.x, this.datasetID, this.address)
                .subscribe(
                    (response) => {
                        const url =  response.url;
                        window.location.href = response.url;
                    },
                    (error) =>
                        this.notifService.error(
                            "Something went wrong during download"
                        )
                )
        )

    }

    downloadMunichReportForSeeInfoReportingEdition() {
        this.subscriptions.add(
            this.downloadService
                .downloadMunichReReportForSeeInfoReportingEdition(this.location.y, this.location.x, this.datasetID, this.address)
                .subscribe(
                    (response) => {
                        const url = response.url;
                        window.location.href = response.url;
                    },
                    (error) =>
                        this.notifService.error(
                            "Something went wrong during download"
                        )
                )
        )

    }

    getTessadataSummaryFieldIds() {
        return [TessadataNriFields.SUMMARY_RISK_RATING, TessadataNriFields.SUMMARY_EAL_RATING, TessadataNriFields.SUMMARY_SOVI_RATING, TessadataNriFields.SUMMARY_RESL_RATING];
    }

    prepareNRICards() {
        this.summaryCard = this.createNRICard('Summary', 'summary.svg', this.getTessadataSummaryFieldIds(), false);
        [
          { title: 'Avalanche', icon: 'avalanche.svg', fields: [TessadataNriFields.AVALANCHE_RSK, TessadataNriFields.AVALANCHE_EAL, TessadataNriFields.AVALANCHE_HLR] },
          { title: 'Coastal Flooding', icon: 'coastalflooding.svg', fields: [TessadataNriFields.COASTAL_FLOODING_RSK, TessadataNriFields.COASTAL_FLOODING_EAL, TessadataNriFields.COASTAL_FLOODING_HLR] },
          { title: 'Cold Wave', icon: 'coldwave.svg', fields: [TessadataNriFields.COLDWAVE_RSK, TessadataNriFields.COLDWAVE_EAL, TessadataNriFields.COLDWAVE_RSK] },
          { title: 'Drought', icon: 'drought.svg', fields: [TessadataNriFields.DROUGHT_RSK, TessadataNriFields.DROUGHT_EAL, TessadataNriFields.DROUGHT_HLR] },
          { title: 'Earthquake', icon: 'earthquake.svg', fields: [TessadataNriFields.EARTHQUAKE_RSK, TessadataNriFields.EARTHQUAKE_EAL, TessadataNriFields.EARTHQUAKE_HLR] },
          { title: 'Hail', icon: 'hail.svg', fields: [TessadataNriFields.HAIL_RSK, TessadataNriFields.HAIL_EAL, TessadataNriFields.HAIL_HLR] },
          { title: 'Heat Wave', icon: 'heatwave.svg', fields: [TessadataNriFields.HEATWAVE_RSK, TessadataNriFields.HEATWAVE_EAL, TessadataNriFields.HEATWAVE_HLR] },
          { title: 'Hurricane', icon: 'tornado.svg', fields: [TessadataNriFields.HURRICANE_RSK, TessadataNriFields.HURRICANE_EAL, TessadataNriFields.HURRICANE_HLR] },
          { title: 'Ice Storm', icon: 'icestorm.svg', fields: [TessadataNriFields.ICESTORM_RSK, TessadataNriFields.ICESTORM_EAL, TessadataNriFields.ICESTORM_HLR] },
          { title: 'Landslide', icon: 'landslide.svg', fields: [TessadataNriFields.LANDSLIDE_RSK, TessadataNriFields.LANDSLIDE_EAL, TessadataNriFields.LANDSLIDE_HLR] },
          { title: 'Lightning', icon: 'lightning.svg', fields: [TessadataNriFields.LIGHTNING_RSK, TessadataNriFields.LIGHTNING_EAL, TessadataNriFields.LIGHTNING_HLR] },
          { title: 'Riverine Flood', icon: 'river.svg', fields: [TessadataNriFields.RIVERINEFLOOD_RSK, TessadataNriFields.RIVERINEFLOOD_EAL, TessadataNriFields.RIVERINEFLOOD_HLR] },
          { title: 'Strong Wind', icon: 'wind.svg', fields: [TessadataNriFields.STRONGWIND_RSK, TessadataNriFields.STRONGWIND_EAL, TessadataNriFields.STRONGWIND_HLR] },
          { title: 'Tornado', icon: 'tornado.svg', fields: [TessadataNriFields.TORNADO_RSK, TessadataNriFields.TORNADO_EAL, TessadataNriFields.TORNADO_HLR] },
          { title: 'Tsunami', icon: 'tsunami.svg', fields: [TessadataNriFields.TSUNAMI_RSK, TessadataNriFields.TSUNAMI_EAL, TessadataNriFields.TSUNAMI_HLR] },
          { title: 'Volcanic Activity', icon: 'volcanic.svg', fields: [TessadataNriFields.VOLCANIC_RSK, TessadataNriFields.VOLCANIC_EAL, TessadataNriFields.VOLCANIC_HLR] },
          { title: 'Wildfire', icon: 'wildfire.svg', fields: [TessadataNriFields.WILDFIRE_RSK, TessadataNriFields.WILDFIRE_EAL, TessadataNriFields.WILDFIRE_HLR] },
          { title: 'Winter Weather', icon: 'winter.svg', fields: [TessadataNriFields.WINTER_RSK, TessadataNriFields.WINTER_EAL, TessadataNriFields.WINTER_HLR] },
        ].forEach(({ title, icon, fields }) => {
          const card = this.createNRICard(title, icon, fields);
          this.nriCards.push(card);
        });
    }

    createNRICard(title: string, icon: string, fieldIds: string[], removePrefixOfAttributes = true): NRICard {
        let properties: NRIKeyValue[] = [];
        let riskNumericalValues: number[] = [];
        const prefix_for_risk = 'risk_index_tract_';
        const riskIndexTract = this.locationDetails?.datasets.find(item => item.datasetId === 'risk_index_tract');
        const riskFields = riskIndexTract?.fields || [];
        fieldIds.forEach(id => {
            let newId = id;
            if (id.startsWith(prefix_for_risk)) {
                newId = id.slice(prefix_for_risk.length);
            }
            let datasetField = riskFields.find(item => item.id === newId);
            if (!datasetField) {
                return;
            }
            let datapointField = datasetField;
            let value: any = datapointField.value || datapointField.textValue || datapointField.numberValue || datapointField.datetimeValue;
            if (typeof value === 'string') {
                const noSpacePattern = /^(\d{1,2})\.(?!\s)(.+)$/;
                const m = noSpacePattern.exec(value.trim());
                if (m) {
                    value = `${m[1]}. ${m[2]}`;
                }
            }
            const numericRisk = value ? NRIUtils.getNumericRiskValue(value.trim()) : undefined;
            if (numericRisk != null) {
                riskNumericalValues.push(numericRisk);
            } else {
                riskNumericalValues.push(10);
            }

            let fieldName = datasetField.label || '';
            let label = removePrefixOfAttributes && fieldName.includes('- ') ? fieldName.substring(fieldName.indexOf('- ') + 2) : fieldName;
            properties.push({ label: label, value: value });
        });

        const maxRisk = riskNumericalValues.length > 0 ? Math.min(...riskNumericalValues) : 10;
        const warnSignColor = NRIUtils.riskValueColorsByNumbers[maxRisk] || '#cccccc';
        const visible = maxRisk <= 5;

        const card: NRICard = { title, icon, properties, warnSignColor, visible };
        return card;
    }
}
interface NRICard {
    title: string;
    icon: string;
    properties: NRIKeyValue[];
    warnSignColor: string;
    visible: boolean;
}

interface NRIKeyValue {
    label: string;
    value: string;
}
